import { graphql, useStaticQuery } from 'gatsby';

// Better to have a list of common queries in one place than to have the same query repeated in multiple components.
// This also allows us to use the query in providers and pass the data down via context, which is better for performance than having multiple components all run the same query with useStaticQuery.
export const useComparisonCardBlockQuery = () => {
	const data = useStaticQuery(graphql`
{
	allSmartTagsComparisonCardBlock(
		filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}}
	) {
		edges {
			node {
				id
				title
				secondaryTitle
				cards {
					name1
					image1
					uri1
					name2
					image2
					uri2
					name3
					image3
					uri3
				}
				background
				backgroundImage
				backgroundProps
				flush
				padding
				Audience {
					...AudienceRelationshipDetailsFragment
				}
			}
		}
	}
}
`);
	return { data };
};